import React from 'react';

import {
  Headline as ODSHeadline,
  HeadlineProps,
} from '@zeiss/ods-components-react';

import { StyledHeadline } from './styled';

const Headline = (props: HeadlineProps) => (
  <StyledHeadline>
    <ODSHeadline {...props} />
  </StyledHeadline>
);

export default Headline;
